import React from 'react';
import { EmailPageBase } from 'components/EmailPageBase/EmailPageBase';
import './style.scss';

export const CheckEmailRegistration = () => {
  return (
    <EmailPageBase>
      <h3 className="title">Проверьте почту!</h3>
      <p className="text-content">
        Зайдите на почту, которую вы указали и нажмите на ссылку в письме, чтобы закончить регистрацию.
      </p>
    </EmailPageBase>
  );
};
